import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';

export const PRODUCT_RESERVATION_REQUEST = 'PRODUCT_RESERVATION_REQUEST';
export const PRODUCT_RESERVATION_SUCCESS = 'PRODUCT_RESERVATION_SUCCESS';
export const PRODUCT_RESERVATION_ERROR = 'PRODUCT_RESERVATION_ERROR';
export const CHANGE_SALE_PHASE = 'CHANGE_SALE_PHASE';
export const CHANGE_USER_STATE = 'CHANGE_USER_STATE';

// Product Reservation
export function productReservationRequestAction() {
	return { type: PRODUCT_RESERVATION_REQUEST };
}

export function productReservationSuccessAction(data) {
	return { type: PRODUCT_RESERVATION_SUCCESS, data };
}

export function productReservationErrorAction(error) {
	return { type: PRODUCT_RESERVATION_ERROR, error };
}

export function changeSalePhaseAction(phase) {
	return { type: CHANGE_SALE_PHASE, data: phase };
}

export function changeUserStateAction(userState) {
	return { type: CHANGE_USER_STATE, data: userState };
}

export function productReservationAction(queryParams) {
	return dispatch => {
		dispatch(productReservationRequestAction());
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				headers,
				pathname: '/api/1/sale/register',
				query: queryParams
			})
		).then(
			data => dispatch(productReservationSuccessAction(data['RESPONSE'])),
			err => dispatch(productReservationErrorAction(err))
		);
	};
}
